
export class Label {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    color_id= null,
                    name= '',
                    type= 'loss_reason',
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    //relations
                    color=null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.company_id=company_id;
        this.color_id=color_id;
        this.name=name;
        this.type=type;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

        this.color=color;

    }

}

export function createLabel(data={}) {
    return Object.freeze(new Label(data));
}